import { Modal } from 'bootstrap';
import { X } from 'lucide-react';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import UserContext from '../../contexts/UserContext';

const Logout = () => {
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

  useEffect(() => {
    const logoutUser = () => {
      // Prevent duplicate toast
      if (!toast.isActive('logout-toaster')) {
        toast.success('Logout successful', { toastId: 'logout-toaster' });
      }

      localStorage.removeItem('userID');
      setUser(null);
      navigate('/');
    };

    const handleLogout = () => {
      const myModal = new Modal(document.getElementById('logoutModal'), {
        keyboard: false,
        backdrop: 'static',
      });
      myModal.show();

      const confirmButton = document.getElementById('confirmLogout');
      const cancelButton = document.getElementById('cancelLogout');

      confirmButton.addEventListener('click', () => {
        logoutUser();
        myModal.hide();
      });

      cancelButton.addEventListener('click', () => {
        myModal.hide();
        navigate('/account/profile');
      });
    };

    handleLogout();
  }, [setUser, navigate]);

  return (
    <div
      className="modal fade"
      id="logoutModal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content">
          {/* Header */}
          <div
            className="bg-light p-3 d-flex justify-content-between align-items-center"
            style={{
              backgroundColor: '#800080',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <h1 className="text-dark fs-5 m-0" style={{ lineHeight: 1.2 }}>
              Logout Confirmation
            </h1>
            <button
              className="border-0 bg-transparent p-0"
              type="button"
              data-bs-dismiss="modal"
              id="cancelLogout"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <X size={20} color="#000" />
            </button>
          </div>

          {/* Body */}
          <div className="modal-body">
            <p className="mb-0">Are you sure you want to logout?</p>
          </div>

          {/* Footer */}
          <div className="bg-light p-3 d-flex gap-2 justify-content-end">
            {/* <button
              type="button"
              className="btn btn-secondary border-0"
              id="cancelLogout"
              data-bs-dismiss="modal"
            >
              Cancel
            </button> */}
            <button
              type="button"
              className="btn btn-primary border-0"
              style={{ backgroundColor: '#800080' }}
              id="confirmLogout"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;
